import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ConfigState,
  AsyncStatus,
  CreditInsightsConfig,
  DashboardConfig,
  TransactionDataConfig,
  ProjectConfig,
} from '@algoan/dashboard/model';
import { updateAuthInformation } from './auth-slice';

const initialState: ConfigState = {
  configFetchingStatus: AsyncStatus.IDLE,
  error: false,
  config: undefined,
};

const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    loadConfigStart(state: ConfigState) {
      state.configFetchingStatus = AsyncStatus.PENDING;
      state.error = false;
    },
    loadConfigFailure(state: ConfigState) {
      state.configFetchingStatus = AsyncStatus.REJECTED;
      state.error = true;
    },
    loadConfigSuccess(
      state: ConfigState,
      action: PayloadAction<{
        dashboard: DashboardConfig;
        creditInsights: CreditInsightsConfig | undefined;
        transactionDataConfig: TransactionDataConfig | undefined;
        projectConfig: ProjectConfig | undefined;
      }>,
    ) {
      state.configFetchingStatus = AsyncStatus.RESOLVED;
      state.error = false;
      state.config = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateAuthInformation, (state, action) => {
      if (typeof action.payload === 'undefined') {
        // we clear the state on logout
        return { ...initialState };
      }

      return state;
    });
  },
});

export const { reducer: configReducer } = configSlice;
export const { loadConfigFailure, loadConfigStart, loadConfigSuccess } = configSlice.actions;
